//Module Keys
let locales = {};

//Merge Views
import main from 'Modules/manufacturers/views/main/lan/en';
import firmwareTab from 'Modules/manufacturers/.components/firmwareTab/lan/en';
import refreshFirmware from 'Modules/manufacturers/.components/refreshFirmware/lan/en';
import deletePartNumber from 'Modules/manufacturers/.components/partNumbersTab/.components/deletePartNumber/lan/en';
import partNumbersTab from 'Modules/manufacturers/.components/partNumbersTab/lan/en';
import createEditPartNumber from 'Modules/manufacturers/.components/partNumbersTab/.components/createEditPartNumber/lan/en';
import deviceModelsTab from 'Modules/manufacturers/.components/deviceModelsTab/lan/en';
import assignFirmware from 'Modules/manufacturers/.components/firmwareTab/.components/assignFirmware/lan/en';
import unitTypesTab from 'Modules/manufacturers/.components/unitTypesTab/lan/en';
import refreshDevicesConfig from 'Modules/manufacturers/.components/refreshDevicesConfig/lan/en';
import cannedCommandsTab from 'Modules/manufacturers/.components/cannedCommandsTab/lan/en';
import createEditCannedCommand from 'Modules/manufacturers/.components/cannedCommandsTab/.components/createEditCannedCommand/lan/en';
import deleteCannedCommand from 'Modules/manufacturers/.components/cannedCommandsTab/.components/deleteCannedCommand/lan/en';
import createEditUnitType from 'Modules/manufacturers/.components/unitTypesTab/.components/createEditUnitType/lan/en';
import deleteUnitType from 'Modules/manufacturers/.components/unitTypesTab/.components/deleteUnitType/lan/en';
import showUnitTypeEvents from 'Modules/manufacturers/.components/unitTypesTab/.components/showUnitTypeEvents/lan/en';
import createEditManufacturer from 'Modules/manufacturers/views/.components/createEditManufacturer/lan/en';
import deleteManufacturer from 'Modules/manufacturers/views/.components/deleteManufacturer/lan/en';
import createEditDeviceModel from 'Modules/manufacturers/.components/deviceModelsTab/.components/createEditDeviceModel/lan/en';
import editAlertTypeSupported from 'Modules/manufacturers/.components/deviceModelsTab/.components/createEditDeviceModel/.components/editAlertTypeSupported/lan/en';
import bulkAssignAlertTypes from 'Modules/manufacturers/.components/deviceModelsTab/.components/bulkAssignAlertTypes/lan/en';
import syncCTCInformation from 'Modules/manufacturers/views/.components/syncCTCInformation/lan/en';

locales = {
    ...locales,
    ...main,
    ...firmwareTab,
    ...refreshFirmware,
    ...deletePartNumber,
    ...partNumbersTab,
    ...createEditPartNumber,
    ...deviceModelsTab,
    ...assignFirmware,
    ...unitTypesTab,
    ...refreshDevicesConfig,
    ...cannedCommandsTab,
    ...createEditCannedCommand,
    ...deleteCannedCommand,
    ...createEditUnitType,
    ...deleteUnitType,
    ...showUnitTypeEvents,
    ...createEditManufacturer,
    ...deleteManufacturer,
    ...createEditDeviceModel,
    ...editAlertTypeSupported,
    ...bulkAssignAlertTypes,
    ...syncCTCInformation,
};


export default locales;